import money from './money';
export default {
  install(Vue) {
    Vue.directive('money', money);
  }
}
